import {FormikProps, FormikHelpers} from 'formik';
import _ from 'lodash';
import {notify} from '@gemcook/notification';

import constants from '@constants';
import utils from '@utils';
import {Props} from './types';

export const addSearchWord = (
  formProps: FormikProps<any>,
  inputFieldName: string,
  searchFieldName: string
) => {
  const inputWord = formProps.values[inputFieldName].trim();
  // 名前欄に入力された文字にスペースが入っていれば分割する
  if (inputFieldName === 'user' && inputWord) {
    utils.search.splitKeyword(
      'user',
      formProps.values.user,
      formProps.values.users,
      formProps
    );
    return;
  }
  // メールアドレス欄に入力された文字にスペースが入っていれば分割する
  if (inputFieldName === 'email' && inputWord) {
    utils.search.splitKeyword(
      'email',
      formProps.values.email,
      formProps.values.emails,
      formProps
    );
    return;
  }
  // 組織欄に入力された文字にスペースが入っていれば分割する
  if (inputFieldName === 'organization' && inputWord) {
    utils.search.splitKeyword(
      'organization',
      formProps.values.organization,
      formProps.values.organizations,
      formProps
    );
    return;
  }
  // 役職欄に入力された文字にスペースが入っていれば分割する
  if (inputFieldName === 'position' && inputWord) {
    utils.search.splitKeyword(
      'position',
      formProps.values.position,
      formProps.values.positions,
      formProps
    );
    return;
  }

  if (inputWord) {
    const searchWords = formProps.values[searchFieldName];
    // 検索キーワードラベルを追加
    searchWords.push({
      text: inputWord,
      id: searchWords.length + 1,
    });
    formProps.setFieldValue(searchFieldName, searchWords);

    formProps.setFieldValue(inputFieldName, '');
  } else {
    return;
  }
};

export const updateCurrent = async (
  props: Props,
  current: number,
  setIsPaging: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setIsPaging(true);
  props.actions.users.updateActiveUsers(
    props.users.pagination.data,
    props.users.pagination.current,
    current,
    props.users.pagination.totalPages
  );

  await props.actions.users.updateCurrentUsers({
    page: current,
    sort: props.users.pagination.sort,
    teamId: props.me.teamId,
    email: props.users.search.email,
    prefecture: props.users.search.prefecture,
    name: props.users.search.name,
    organization: props.users.search.organization,
    position: props.users.search.position,
    isEmailBounced: props.users.search.isEmailBounced,
  });
  setIsPaging(false);
};

export const searchUsers = async (
  values: any,
  formikHelpers: FormikHelpers<any>,
  props: Props,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  formikHelpers.setSubmitting(true);
  setLoading(true);

  // 名前欄に入力されていた場合、検索キーワードに入れる
  if (values.user) {
    utils.search.splitKeyword('user', values.user, values.users, formikHelpers);
  }
  // メールアドレス欄に入力された文字にスペースが入っていれば分割する
  if (values.email) {
    utils.search.splitKeyword(
      'email',
      values.email,
      values.emails,
      formikHelpers
    );
  }
  // 組織欄に入力された文字にスペースが入っていれば分割する
  if (values.organization) {
    utils.search.splitKeyword(
      'organization',
      values.organization,
      values.organizations,
      formikHelpers
    );
  }
  // 役職欄に入力された文字にスペースが入っていれば分割する
  if (values.position) {
    utils.search.splitKeyword(
      'position',
      values.position,
      values.positions,
      formikHelpers
    );
  }

  // 検索対象のユーザー名の配列を作成
  const name = values.users.map((user: any) => user.text);
  // 検索対象の所属組織の配列を作成
  const organization = values.organizations.map(
    (organization: any) => organization.text
  );
  // 検索対象の役職の配列を作成
  const position = values.positions.map((position: any) => position.text);
  // 検索対象のメールアドレスの配列を作成
  const email = values.emails.map((email: any) => email.text);
  if (_.isNull(values.prefecture)) {
    values.prefecture = undefined;
  }

  // 検索条件をstoreに保存
  let isEmailBounced;
  if (values.isEmailBounced) {
    isEmailBounced = true;
  } else {
    // メール配信エラーにチェックが入っていない場合、パラメーターを渡さない
    isEmailBounced = undefined;
  }
  try {
    await props.actions.users.updateSearchWordsUsers(
      {
        prefecture: values.prefecture,
        email,
        name,
        organization,
        position,
        teamId: props.me.teamId,
        isEmailBounced,
        sort: '-createdAt',
      },
      props.me.teamId
    );
  } catch (error) {
    notify(constants.ERRORS.UNKNWON, 'error');
  } finally {
    setLoading(false);
    formikHelpers.setSubmitting(false);
  }
};
